import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormFieldElement, FormFieldType, FormGenerator } from '../form-generator.models';

const KNOWN_VALIDATION_ERROR_ORDER = ['required', 'pattern', 'minlength', 'maxlength', 'min', 'max'];

@Component({
    selector: 'payments-form-generator',
    templateUrl: './form-generator.component.html',
    styleUrls: ['./form-generator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormGeneratorComponent {
    @Input() formGenerator: FormGenerator;

    formFieldType = FormFieldType;
    formFieldElement = FormFieldElement;

    getValidationErrorKeys(control: AbstractControl): string[] {
        const errors = control?.errors;
        if (!errors) {
            return [];
        }

        const keys = Object.keys(errors);
        const knownKeys = KNOWN_VALIDATION_ERROR_ORDER.filter((key) => keys.includes(key));
        const unknownKeys = keys.filter((key) => !KNOWN_VALIDATION_ERROR_ORDER.includes(key));

        return [...knownKeys, ...unknownKeys];
    }
}
